"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwincastAbilityHandler = exports.TwincastActorAbilityFactory = exports.TwincastAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const enums_1 = require("../../core/enums");
class TwincastAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Twincast;
        this.__typeName = "Twincast";
    }
}
exports.TwincastAbilityArgs = TwincastAbilityArgs;
let TwincastActorAbilityFactory = class TwincastActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Twincast", "Self", 0);
    }
};
TwincastActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Twincast")
], TwincastActorAbilityFactory);
exports.TwincastActorAbilityFactory = TwincastActorAbilityFactory;
let TwincastAbilityHandler = class TwincastAbilityHandler {
    init(sequence, container, actorId) {
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            supernatural: true,
            duration: Duration_1.Duration.Permanent,
            effect: new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.ExtraActions, 1),
            onApplied: sequence => sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(actorId, "feet"), "OrangeRunesRising"))
        });
    }
    activate(sequence, container, ability) { }
};
TwincastAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Twincast)
], TwincastAbilityHandler);
exports.TwincastAbilityHandler = TwincastAbilityHandler;
